export default {
  list: '/portal/propertySmokeProfiles/',
}
